import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface StatCardProps {
  icon: string;
  title: string;
  value: string;
  percentage: number;
  trend?: 'up' | 'down';
  infoText?: string;
}

export function StatCard({
  icon,
  title,
  value,
  percentage,
  trend = 'up',
  infoText
}: StatCardProps) {
  const isPositive = trend === 'up';

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props} className="custom-tooltip">
      {infoText}
    </Tooltip>
  )

  return (
    <div className="rounded-1 py-3 px-3 h-100" style={{ backgroundColor: `var(--background-secondary)` }}>
      <div className="d-flex align-items-center gap-3">
        {/* Icon Container */}
        <div className="p-2 px-3 bg-opacity-10 rounded-4 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: `var(--background-primary)`, color: `var(--scrollbar-thumb)` }}>
          <i
            className={icon}
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              WebkitTextStroke: '0.4px currentColor',
              color: 'var(--scrollbar-thumb)'
            }}
          ></i>
        </div>

        {/* Content */}
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center">
            <span className="text-uppercase text-muted fw-bold small mb-0" style={{ fontSize: '0.85rem', letterSpacing: '0.05em' }}>
              {title}
            </span>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <i className="bi bi-info-circle ms-2" />
            </OverlayTrigger>
          </div>



          <div className="d-flex align-items-baseline gap-2">
            <h4 className="fw-bold mb-0 text-dark">
              {value}
            </h4>

            <div className={`d-flex align-items-center small fw-bold`} style={{ color: isPositive ? 'var(--IDGreen)' : 'var(--IDDanger)' }}>
              {isPositive ? (
                <i className="bi bi-arrow-up-right me-1"></i>
              ) : (
                <i className="bi bi-arrow-down-right me-1"></i>
              )}
              <span>{percentage}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
